import React, { useEffect, useState } from "react";
import AvatarStep from "components/onboarding/_steps/AvatarStep";

const AvatarAndPseudoStepUnwraped = ({
	quizOrganizationId,
	player,
	onComplete,
	closeModal,
}) => {
	const [pseudo, setPseudo] = useState(player?.pseudo || "");
	const [avatar, setAvatar] = useState(player?.avatar || null);

	useEffect(() => {
		setAvatar(player?.avatar || null);
		setPseudo(player?.pseudo || "");
	}, [player]);

	const handlePseudoChosen = (chosenPseudo) => {
		setPseudo(chosenPseudo);
	};

	const handleAvatarChosen = (chosenAvatar) => {
		setAvatar(chosenAvatar);
	};

	const handleValidation = () => {
		if (pseudo && avatar) {
			onComplete({ pseudo, avatar });
			if (closeModal) {
				closeModal();
			}
		}
	};

	return (
		<div className="flex flex-col items-center w-full h-full">
			<div className="flex flex-col gap-2 items-start mb-4 w-full">
				<p className="text-md text-gray-700">Pseudo:</p>
				<input
					type="text"
					value={pseudo}
					onChange={(e) => handlePseudoChosen(e.target.value)}
					className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-black"
				/>
			</div>

			<AvatarStep
				quizOrganizationId={quizOrganizationId}
				player={player}
				onAvatarChosen={handleAvatarChosen}
			/>

			<div className="flex flex-col gap-2 items-center mt-4">
				<button
					onClick={handleValidation}
					disabled={!pseudo || !avatar}
					className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
				>
					Valider
				</button>
			</div>
		</div>
	);
};

export default AvatarAndPseudoStepUnwraped;
